import { useState, useEffect, SetStateAction, Dispatch } from "react";
import _ from "lodash";
import { InjectedRouter } from "react-router";
import { Location } from "history";
import { ISort, ISortOrder } from "constants/types";
import { fromJS, OrderedMap } from "immutable";

type State<S> = [S, Dispatch<SetStateAction<S>>];

export const useQueryFilters = (location: Location, router?: InjectedRouter): State<OrderedMap<string, string>> => {
    const [filters, setFilters] = useState<OrderedMap<string, string>>(
        fromJS(_.omit(location.query, ["__sort", "__sort_order", "__search"]))
    );
    useEffect(() => {
        router?.replace({
            pathname: location.pathname,
            query: _.pickBy({ ..._.pickBy(location.query, ["__sort", "__sort_order", "__search"]), ...filters.toJS() }),
        });
    }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps
    return [filters, setFilters];
};

export const useQuerySearch = (location: Location, router?: InjectedRouter): State<string> => {
    const [search, setSearch] = useState<string>((location.query?.__search as string) || "");
    useEffect(() => {
        router?.replace({
            pathname: location.pathname,
            query: _.pickBy({ ...location.query, __search: search }),
        });
    }, [search]); // eslint-disable-line react-hooks/exhaustive-deps
    return [search, setSearch];
};

export const useQuerySort = (location: Location, defaults: ISort, router?: InjectedRouter): State<ISort> => {
    const [sort, setSort] = useState<ISort>({
        sort: (location.query?.__sort as string) || defaults.sort,
        sortOrder: (location.query?.__sort_order as ISortOrder) || defaults.sortOrder,
    });
    useEffect(() => {
        router?.replace({
            pathname: location.pathname,
            query: _.pickBy({
                ...location.query,
                __sort: sort.sort !== defaults.sort && sort.sort,
                __sort_order: sort.sortOrder !== defaults.sortOrder && sort.sortOrder,
            }),
        });
    }, [sort]); // eslint-disable-line react-hooks/exhaustive-deps
    return [sort, setSort];
};
